namespace Solovis.UI.InputControls {

    export interface ParameterInputControlOptions extends Solovis.UI.BaseControlOptions {
        portalServices?: Solovis.Portal.IPortalServices;

        // width: width of the control
        width?: any;
        // required: whether or not the input is required
        required?: boolean;
        // value: initial value
        value?: any;
        // The parameter type
        parameterType?: string;
        // The fully qualified name of the ParameterControl
        parameterControlTypeName?: string;
        // settings for the parameterControl
        settings?: any;
        // custom change function
        change?: any;
        // custom validation function called with ParameterInputControl as "this". Must make use of this.validationModel
        validate?: any;

        validationModel?: Solovis.UI.InputControls.ValidationModel;
    }

    export class ParameterInputControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _width: any;
        public _required: boolean;
        public _value: any;
        public _parameterType: string;
        public _parameterControlTypeName: string;
        public _settings: any;
        public _validate: any;
        public _change: any;

        public validationModel: Solovis.UI.InputControls.ValidationModel;

        public _controlHostDiv: JQuery;
        public _parameterControl: any;


        constructor(options: ParameterInputControlOptions) {
            super(options);

            var self = this;

            if (!options.parameterType && !options.parameterControlTypeName) {
                throw "Missing required parameter: parameterType or parameterControlTypeName.";
            }

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._width = options.width ? options.width : null;
            this._required = options.required ? options.required : false;
            this._value = Solovis.isNotNull(options.value) ? options.value : null;

            this._parameterType = options.parameterType ? options.parameterType : null;
            this._parameterControlTypeName = options.parameterControlTypeName ? options.parameterControlTypeName : null;
            this._settings = options.settings ? options.settings : null;

            this._validate = options.validate ? options.validate : null;
            this._change = options.change ? options.change : null;

            this.validationModel = options.validationModel ? options.validationModel : new Solovis.UI.InputControls.ValidationModel();
        }


        public doRender() {
            var self = this;

            this.container.addClass("solovis-parameterControl-container solovis-input");

            this._controlHostDiv = $("<div>").appendTo(this.container);
            this._attachParameterControl();
        }

        public _attachParameterControl() {
            var self = this;

            var parameterControlTypeName: string = this._parameterControlTypeName;
            if (this._parameterType) {
                // Reports cannot be made a dependency of this module.
                parameterControlTypeName = (Solovis as any).Reports.ParameterTypes.getParameterControlForParameterType(this._parameterType);

                if (!parameterControlTypeName) {
                    throw "Unable to find parameter control type: " + this._parameterType;
                }
            }

            var parameterControlType = Solovis.resolveObject(parameterControlTypeName);
            if (!parameterControlType) {
                throw "Unable to resolve: " + parameterControlTypeName;
            }

            let performInit = (loadedValue) => {
                self._parameterControl = new parameterControlType({
                    controlHost: self._controlHostDiv,
                    initialValue: loadedValue,
                    settings: self._settings,
                    portalServices: this._portalServices,
                    renderMode: this.options.renderMode
                });
                
                self._parameterControl.setAsCurrentControl();

                $(self._parameterControl).bind("parameterValueChanged", function () {
                    self.notifyValueChanged();
                });
            };

            if (parameterControlType.preload) {
                if (!parameterControlType.shouldPreload || parameterControlType.shouldPreload(this._value)) {
                    parameterControlType.preload(
                        this._value,
                        function (loadedValue, success) {
                            if (success) {
                                performInit(loadedValue);

                                $(self).trigger("initialValuePreloaded");
                            }
                            else {
                                throw "Failed to load parameter control: " + parameterControlType;
                            }
                        },
                        this._portalServices);
                }
                else {
                    performInit(this._value);
                }
            }
            else {
                performInit(this._value);                
            }
        }

        public value(value?: any): any {
            if (arguments.length) {
                this.setValue(value);
            }
            return this.getValue();
        }

        public notifyValueChanged(): void {
            $(this).trigger("valueChanged");
            if (this._change) {
                this._change();
            }
        };

        public isValid(): boolean {
            this.doValidate();
            return !this.validationModel.hasError();
        }

        public focus() {
            if (this._parameterControl && this._parameterControl.focus) {
                this._parameterControl.focus();
            }
        }

        /**
         * Triggers update of validation model which may update validation model controls that show error conditions.
         */
        public doValidate(): void {
            this.validationModel.clearState();

            if (Solovis.isNull(this.value()) && this._required) {
                this.validationModel.setErrorMessage("This is a required field.");
            }

            if (!this.validationModel.hasError() && this._validate) {
                this._validate();
            }
        }

        public getValue(): any {
            if (this._parameterControl) {
                return this._parameterControl.getParameterValue();
            }
            else {
                // Return the initial value if the parameter control hasn't been setup yet.
                return this._value;
            }
        }

        public setValue(value: any): void {
            this._parameterControl.setParameterValue(value);
            this.doValidate();
        }
    }

}


    
